export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "progress-message-skills": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["mandatory <b>skills</b> approved"])},
        "progress-message-hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<b>hours</b> completed"])},
        "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["of"])}
      },
      "fr": {
        "progress-message-skills": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["des <b>compétences</b> obligatoires approuvées"])},
        "progress-message-hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<b>heures</b> effectuées"])},
        "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["de"])}
      }
    }
  })
}